module.exports = __webpack_public_path__ + "img/course.512cae4b.png";